const hostname = window.location.hostname;

const env: any = {
  SERVER_URL: 'https://retail-api.krg.io',
  IMPORT_URL: 'https://retail-api.krg.io',
  FEEDS_FILENAME: 'test-feeds.json',
  S3_LOCATION: 'https://storage.cloud.kargo.com/ad/retail-api',
  SSO: 'https://sso.krg.io',
  SSO_LOGIN: `/login?redirect_url=https://retail-api.krg.io`
};

const currentEnv = hostname.includes('.krg.io') ? 'local'
  : hostname.includes('.dev.') ? 'dev'
  : hostname.includes('.staging.') ? 'staging'
  : 'prod';

switch (currentEnv) {
  case 'dev':
    env.SERVER_URL = 'https://retail-api.dev.kargo.com';
    env.IMPORT_URL = 'https://retail-api-import.dev.kargo.com';
    env.SSO = 'https://sso.dev.kargo.com';
    env.SSO_LOGIN = `/login?redirect_url=https://retail-api.dev.kargo.com`;
    break;
  case 'staging':
    env.SERVER_URL = 'https://retail-api-master.dev.kargo.com';
    env.IMPORT_URL = 'https://retail-api-import-master.dev.kargo.com';
    env.SSO = 'https://sso.staging.kargo.com';
    env.SSO_LOGIN = `/login?redirect_url=https://retail-api-master.dev.kargo.com`;
    break;
  case 'prod':
    env.SERVER_URL = 'https://retail-api.kargo.com';
    env.IMPORT_URL = 'https://retail-api-import.kargo.com';
    env.FEEDS_FILENAME = 'feeds.json';
    env.SSO = 'https://sso.kargo.com';
    env.SSO_LOGIN = `/login?redirect_url=https://retail-api.kargo.com`;
    break;
}

export default env;
